import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M11 6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2v2a1 1 0 0 0-1 1v1c0 .029.002.058.004.086a2 2 0 0 0-1.417 1.83l-.543 13.042A1 1 0 0 0 7.043 26h5.915a1 1 0 0 0 1-1.042l-.544-13.041a2 2 0 0 0-1.417-1.831c.002-.028.004-.057.004-.086V9a1 1 0 0 0-1-1V6z"></path><path d="M20 6a1 1 0 0 0-1 1v2.126c-1.725.444-3 2.01-3 3.874v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V13a4.002 4.002 0 0 0-3-3.874V7a1 1 0 0 0-1-1h-2z"></path></g>';
export var BeautyProductsSVG = function BeautyProductsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BeautyProductsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BeautyProductsSVG);